if (!customElements.get('prepaid-offer-trigger')) {
  customElements.define(
    'prepaid-offer-trigger',
    class PrepaidOfferTrigger extends HTMLElement {
      connectedCallback() {
        this.modal = document.getElementById(this.dataset.modal);
        if (!this.modal) return;
        this.percent = parseFloat(this.dataset.percent) || 5;
        try {
          this.variants = JSON.parse(this.querySelector('[data-prepaid-variants]').textContent);
        } catch (e) {
          this.variants = [];
        }

        this.render(this.currentVariantId());
        this.wireButtons();

        // Follow the chosen pack while the page is open.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const v = event && event.data && event.data.variant;
            if (v && v.id) this.render(v.id);
          });
        }

        this.storageKey = 'prepaid-offer-shown';
        if (this.seen()) return;

        this.boundScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.boundScroll, { passive: true });
        this.timer = setTimeout(() => this.open(), parseInt(this.dataset.delay, 10) || 8000);
      }

      disconnectedCallback() {
        this.disarm();
        if (this.unsubscribe) this.unsubscribe();
      }

      seen() {
        try { return !!sessionStorage.getItem(this.storageKey); } catch (e) { return false; }
      }

      markSeen() {
        try { sessionStorage.setItem(this.storageKey, '1'); } catch (e) { /* private mode */ }
      }

      disarm() {
        clearTimeout(this.timer);
        if (this.boundScroll) window.removeEventListener('scroll', this.boundScroll);
      }

      onScroll() {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0) return;
        if ((window.scrollY / max) * 100 >= (parseFloat(this.dataset.scroll) || 35)) this.open();
      }

      open() {
        if (this.seen()) return this.disarm();
        // Never stack on another popup (exit intent, cart drawer, media).
        if (document.querySelector('modal-dialog[open], cart-drawer.active, details[open] > .menu-drawer')) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.open(), 4000);
          return;
        }
        this.disarm();
        this.markSeen();
        this.render(this.currentVariantId());
        this.modal.show();
        this.countDown();
      }

      currentVariantId() {
        const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        return input ? parseInt(input.value, 10) : null;
      }

      money(paise) {
        const rupees = Math.round(paise / 100);
        return '₹' + rupees.toLocaleString('en-IN');
      }

      fill(template, values) {
        return String(template || '').replace(/\[(\w+)\]/g, (m, key) => (key in values ? values[key] : m));
      }

      render(variantId) {
        const v = this.variants.find((x) => x.id === variantId) || this.variants[0];
        if (!v) return;
        const q = (sel) => this.modal.querySelector(sel);
        const pct = this.percent;

        const price = v.price;
        const mrp = v.compare_at_price > price ? v.compare_at_price : 0;
        const final = Math.round((price * (100 - pct)) / 100 / 100) * 100;
        const extra = price - final;
        const sale = mrp ? Math.round(((mrp - price) / mrp) * 100) : 0;
        const total = mrp ? Math.round(((mrp - final) / mrp) * 100) : pct;

        q('[data-prepaid-heading]').textContent = mrp
          ? this.fill(this.dataset.headingSale, { sale, percent: pct })
          : this.fill(this.dataset.headingNoSale, { percent: pct });

        const variantLabel = q('[data-prepaid-variant]');
        if (variantLabel) variantLabel.textContent = v.title && v.title !== 'Default Title' ? ' - ' + v.title : '';

        q('[data-prepaid-mrp-row]').hidden = !mrp;
        if (mrp) q('[data-prepaid-mrp]').textContent = this.money(mrp);
        q('[data-prepaid-price]').textContent = this.money(price);
        const chip = q('[data-prepaid-sale-chip]');
        if (chip) {
          chip.hidden = !mrp;
          chip.textContent = mrp ? sale + '% OFF' : '';
        }
        this.finalFrom = price;
        this.finalTo = final;
        q('[data-prepaid-final]').textContent = this.money(final);
        q('[data-prepaid-saving]').textContent = this.fill(this.dataset.savingText, {
          saved: this.money((mrp || price) - final),
          amount: this.money(extra),
          total,
          percent: pct,
        });

        const badge = q('[data-prepaid-badge]');
        if (badge) {
          badge.hidden = false;
          badge.textContent = '-' + pct + '%';
        }
        const img = q('[data-prepaid-image]');
        if (img && v.image) img.src = v.image;
      }

      /* The prepaid price ticks down from today's price as the popup opens. */
      countDown() {
        const el = this.modal.querySelector('[data-prepaid-final]');
        if (!el || this.finalFrom == null) return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const from = this.finalFrom;
        const to = this.finalTo;
        const start = performance.now();
        const ms = 900;
        const step = (now) => {
          const t = Math.min(1, (now - start) / ms);
          const eased = 1 - Math.pow(1 - t, 3);
          el.textContent = this.money(from + (to - from) * eased);
          if (t < 1) requestAnimationFrame(step);
          else el.classList.add('is-landed');
        };
        el.classList.remove('is-landed');
        setTimeout(() => requestAnimationFrame(step), 350);
      }

      wireButtons() {
        this.modal.querySelector('[data-prepaid-dismiss]')?.addEventListener('click', () => this.modal.hide());
        const cta = this.modal.querySelector('[data-prepaid-cta]');
        cta?.addEventListener('click', () => this.checkout(cta));
      }

      /*
       * Straight to checkout with the pack they picked. The product page's
       * own BUY NOW is Shiprocket's checkout button (it reads the selected
       * variant and quantity from the product form), so pressing it opens the
       * same checkout, with the prepaid discount applied there. Without it,
       * fall back to Shopify: add the variant to the cart, open /checkout.
       */
      checkout(cta) {
        if (cta.disabled) return;
        const buttons = [...document.querySelectorAll('.sr-headless-checkout')];
        const srButton = buttons.find((b) => b.offsetParent !== null) || buttons[0];
        this.modal.hide();
        if (srButton) {
          srButton.click();
          return;
        }

        cta.disabled = true;
        const id = this.currentVariantId() || (this.variants[0] && this.variants[0].id);
        const qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
        const quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity }] }),
        })
          .then(() => { window.location.href = '/checkout'; })
          .catch(() => { cta.disabled = false; window.location.href = '/cart'; });
      }
    }
  );
}
